export const SET_PENDING_INVITE_USERS = 'set_pending_invite_users'
export const SET_GENERAL_OVERVIEW = 'set_general_overview'
export const SOFT_RESET_ORGANIZATIONS = 'soft_reset_organizations'
